import { useQuery } from '@tanstack/react-query';
import { queryKey } from '../../../../../constant/queryKey';
import { memberRequestsAvailabilityService } from 'shared/src/api/memberRequestsAvailabilityService';

export const useMemberRequestsAvailability = (marketId: number) => {
  return useQuery({
    queryKey: queryKey.memberRequestsAvailability(marketId),
    queryFn: () => memberRequestsAvailabilityService.get(marketId),
  });
};
